import { bind } from '@react-rxjs/core'
import { createSignal } from '@react-rxjs/utils'
import { scan, startWith } from 'rxjs'

interface ModalState {
  isOpen: boolean
}

const initialState: ModalState = {
  isOpen: false,
}

const [modalState$, setModalState] = createSignal<Partial<ModalState>>()

const [useModalState] = bind(
  modalState$.pipe(
    startWith(initialState),
    scan((state, changes) => ({ ...state, ...changes }), initialState),
  ),
  initialState,
)

export const openModal = () => {
  setModalState({ isOpen: true })
}

export const closeModal = () => {
  setModalState(initialState)
}

export { useModalState }
